// Centralized category configuration - SINGLE SOURCE OF TRUTH
// This file defines the complete mapping between UI categories, services, and business category slugs

export const CATEGORY_CONFIG = [
  {
    id: 'wedding-requisites',
    title: 'Wedding Requisites',
    services: [
      { name: 'Banquet Halls', slug: 'banquet-halls' },
      { name: 'Bridal Requisite', slug: 'bridal-requisite' },
      { name: 'Caterers', slug: 'caterers' }
    ]
  },
  {
    id: 'beauty-spa',
    title: 'Beauty & Spa',
    services: [
      { name: 'Beauty Parlours', slug: 'beauty-spa' },
      { name: 'Spa & Massages', slug: 'spa-massage' },
      { name: 'Salons', slug: 'salons' }
    ]
  },
  {
    id: 'repairs-services',
    title: 'Repairs & Services',
    services: [
      { name: 'AC Service', slug: 'ac-service' },
      { name: 'Car Service', slug: 'car-service' },
      { name: 'Bike Service', slug: 'bike-service' }
    ]
  },
  {
    id: 'daily-needs',
    title: 'Daily Needs',
    services: [
      { name: 'Movies', slug: 'movies', status: 'coming_soon' },
      { name: 'Grocery', slug: 'grocery',status: 'active' },
      { name: 'Electricians', slug: 'electricians',status: 'active' }
    ]
  }
];

// Helper: Get all service slugs for validation
export const ALL_SERVICE_SLUGS = CATEGORY_CONFIG.flatMap(category =>
  category.services.map(service => service.slug)
);

// Helper: Validate category slug
export const isValidCategory = (slug) =>
  CATEGORY_CONFIG.some(category =>
    category.services.some(service => service.slug === slug)
  );

// Helper: Get service by slug
export const getServiceBySlug = (slug, { onlyActive = false } = {}) => {
  for (const category of CATEGORY_CONFIG) {
    const service = category.services.find(s => s.slug === slug);
    if (!service) continue;
    if (onlyActive && service.status !== 'active') return null;
    return service;
  }
  return null;
};

// Helper: Get category by service slug
export const getCategoryByServiceSlug = (slug) => {
  return CATEGORY_CONFIG.find(category =>
    category.services.some(service => service.slug === slug)
  );
};

export const getActiveServices = () =>
  CATEGORY_CONFIG.flatMap(category =>
    category.services.filter(service => service.status === 'active')
  );

  export const getServiceStatus = (slug) => {
  const service = getServiceBySlug(slug);
  return service?.status || 'active';
};
